(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-legal-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const base = 'https://cdn.shopify.com/s/files/1/0821/3158/3318/files/';
    const files = {
      de: 'eu-gewaehrleistung-de-2026.png?v=1790016281',
      en: 'eu-legal-guarantee-en-2026.jpg?v=1790016389',
      fr: 'eu-gewaehrleistung-fr-2026.png?v=1790016302',
      es: 'eu-gewaehrleistung-es-2026.png?v=1790016310',
      it: 'eu-gewaehrleistung-it-2026.png?v=1790016318',
      pt: 'eu-gewaehrleistung-pt-2026.png?v=1790016325'
    };
    const syncNoticeLanguage = () => {
      const requested = document.documentElement.lang.toLowerCase().split('-')[0];
      const language = files[requested] ? requested : 'en';
      document.querySelectorAll('[data-eu-legal-notice]').forEach(notice => {
        const image = notice.querySelector('img');
        const link = notice.querySelector('.eu-legal-notice__link');
        if (image && image.src !== base + files[language]) image.src = base + files[language];
        if (link) link.href = 'https://europa.eu/youreurope/citizens/consumers/shopping/guarantees-returns/index_' + language + '.htm';
      });
    };
    const start = () => {
      syncNoticeLanguage();
      document.addEventListener('click', event => {
        const openButton = event.target.closest('[data-eu-notice-open]');
        const closeButton = event.target.closest('[data-eu-notice-close]');
        if (openButton) {
          const dialog = openButton.closest('[data-eu-legal-notice]').querySelector('dialog');
          if (dialog && !dialog.open) dialog.showModal();
        }
        if (closeButton) closeButton.closest('dialog').close();
      });
      new MutationObserver(syncNoticeLanguage).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
      new MutationObserver(records => {
        if (records.some(record => Array.from(record.addedNodes).some(node =>
          node.nodeType === 1 && (node.matches('[data-eu-legal-notice]') || node.querySelector('[data-eu-legal-notice]'))
        ))) syncNoticeLanguage();
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
